import { useState } from "react";
import { AiFillCloseCircle, AiFillPlusCircle } from "react-icons/ai";

function Accordion({ question, answer, content, index }) {
  const [expand, setExpand] = useState(false);
  function handleExpand() {
    setExpand(!expand);
  }

  return (
    <div>
      <section
        className={expand ? "accordion accordion-active" : "accordion"}
        onClick={handleExpand}
        onKeyDown={handleExpand}
        tabIndex={0}
        role="button"
      >
        <div className={expand ? "top-div-active top-div" : "top-div"}>
          <div className="top-div__content">
            <p className="index">{index}</p>
            <div>
              <p className="top-div__text">{question}</p>
              <div
                style={{
                  display: expand ? "block" : "none",
                }}
                className="bottom-div"
              >
                {" "}
                <p className="bottom-div__header"> {answer}</p>{" "}
              </div>{" "}
            </div>
            <p className="top-div__btn">
              {expand ? (
                <AiFillCloseCircle
                  style={{ fontSize: "32px", color: "#3E54AC" }}
                />
              ) : (
                <AiFillPlusCircle
                  style={{ fontSize: "32px", color: "#F3F5F6" }}
                />
              )}
            </p>{" "}
          </div>{" "}
        </div>{" "}
      </section>
    </div>
  );
}

export default Accordion;
